module.exports = __webpack_public_path__ + "img/bondhu.db3ccfa9.jpeg";